import React, { memo, useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

import { CONTEXT } from '../../config';
import WallpaperOpt from '../WallpaperCard/WallpaperOpt';
import styles from './WallpaperGroup.module.less';
import useLoginStatus from '../../utils/hooks/useLoginStatus';

import transparent from '../../static/transparent.svg';
import wpImgDeffl from '../../static/wp/wp_other_default.png';
import wpImgDefsc from '../../static/wp/wp_rectangle_default.png';
import wpImgDefcy from '../../static/wp/wp_frame_default.png';

const selectDownloadImgs = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpDowloadImgs,
);
const selectWallpaper = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpOpteration,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

/**
 * cardInfo: {
 *   classType      // 用于判断此图片展示那个class
 *   isPreview      // 是否展示放大按钮
 *   isDeleteUsed   // 是否展示删除按钮，曾经使用的壁纸
 *   isDeleteColl   // 是否展示删除按钮，点过赞的
 *   isDeleteTurn   // 是否展示删除轮播列表
 *   isWallpaper    // 是否展示设为壁纸按钮
 *   isCollect      // 是否展示点赞按钮
 *   isPayCard      // 表示订单卡片 不展示作责、收藏相关信息
 */
export default memo(({ wallpaper, cardInfo, logInfo }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const loginStatus = useLoginStatus();

  const {} = useSelector(selectWallpaper);
  const logInfoData = useSelector(selectLogInfo);

  const [imgClass, setImgClass] = useState(styles.small_image);
  // 判断是否是在视口范围内
  const [refRenderDom, inRenderDom] = useInView({
    threshold: 0,
    skip: false,
    initialInView: true,
    rootMargin: '400px 0px 400px 0px',
    root: cardInfo?.node,
  });

  // 初始话className
  useEffect(() => {
    if (cardInfo.classType === 'small') {
      setImgClass(`${styles.small_image}  ${styles.space}`);
    } else if (cardInfo.classType === 'small_space') {
      setImgClass(`${styles.small_image}`);
    } else if (cardInfo.classType === 'big') {
      setImgClass(`${styles.big_image} ${styles.space}`);
    } else if (cardInfo.classType === 'big_space') {
      setImgClass(`${styles.big_image}`);
    } else if (cardInfo.classType === 'fit_space') {
      setImgClass(`${styles.fit_image}`);
    } else {
      setImgClass(`${styles.default_image}`);
    }
  }, [cardInfo]);

  const handleImg = useCallback(wp => {
    if (wp?.contentId && wp?.groupType === '2') {
      let contArr = wp?.contentId?.split('#');
      history.push(
        `${CONTEXT}/wallpaper/wpcategory?classId=${contArr[0] || '-1'}&tagId=${contArr[1] || '-1'}`,
      );
    } else if (wp?.groupType === '3') {
      history.push(`${CONTEXT}/wallpaper/wpmine/setup`);
    } else if (wp?.groupType === '4') {
      history.push(`${CONTEXT}/wallpaper/wpmine/collect`);
    } else {
      history.push(`${CONTEXT}/wallpaper/wprecommend`);
    }
  }, []);

  let nameText = '已下架';
  if (wallpaper?.groupName && wallpaper?.contentName) {
    nameText = `${wallpaper?.groupName} ${wallpaper?.contentName}`;
  } else if (!wallpaper?.groupName && wallpaper?.contentName) {
    nameText = `${wallpaper?.contentName}`;
  } else if (wallpaper?.groupName && !wallpaper?.contentName) {
    nameText = `${wallpaper?.groupName}`;
  }
  let wpImg = transparent;
  if (wallpaper?.groupType === '2') {
    wpImg = wallpaper?.img || wpImgDeffl;
  } else if (wallpaper?.groupType === '3') {
    wpImg = wpImgDefcy;
  } else if (wallpaper?.groupType === '4') {
    wpImg = wpImgDefsc;
  }

  return (
    <div className={`${styles.wpimg} ${imgClass} `} ref={refRenderDom}>
      <div className="wpimg_box">
        <img
          className="wpimg_img"
          src={wpImg || transparent}
          onClick={() => handleImg(wallpaper)}
          alt=""
        />
        <div className="wpimg_info" onClick={() => handleImg(wallpaper)}>
          <div></div>
          <div className="wpimg_opt">
            <WallpaperOpt
              wallpaper={wallpaper}
              cardInfo={{ ...cardInfo, isDeleteTurn: true }}
              logInfo={logInfo}
            />
          </div>
        </div>
        <div className="wpimg_shadow" onClick={() => handleImg(wallpaper)}>
          <div
            className={`wpimg_shadow_icon icon iconfont ${
              wallpaper?.groupType === '3'
                ? 'icon-wp_turn_cy'
                : wallpaper?.groupType === '4'
                ? 'icon-wp_turn_sc'
                : 'icon-wp_turn_fl'
            }`}
          ></div>
          <div className="wpimg_shadow_text">{nameText}</div>
        </div>
      </div>
    </div>
  );
});
